export default __webpack_public_path__ + "static/media/fergus_page_five.2cc87038.svg";